export default __webpack_public_path__ + "static/media/saintdenisreunion.55ae2ee9.png";